const cartInfoReducer = (cartInfo = {}, action) => {
  if (action.type === "CART_INFO") {
    return action.payload;
  }
  return cartInfo;
};

export default cartInfoReducer;
